module.exports = __webpack_public_path__ + "static/media/logo.e459fb0f.png";